import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ToolTip from '../ToolTip';
import './DeficiencyIcon.css';

/**
 * DeficiencyIcon Component
 * Displays a clickable icon indicating a report is linked to a deficiency
 * Only renders when deficiency prop is provided
 */
const DeficiencyIcon = (props) => {
  const { deficiency, onClick, className, tooltipText, intl } = props;

  // Don't render if no deficiency data
  if (!deficiency || !deficiency._id) {
    return null;
  }

  /**
   * Handle click event
   */
  const handleClick = (e) => {
    e.stopPropagation(); // Prevent row click event
    onClick(deficiency);
  };

  // Generate tooltip text
  const tooltip = tooltipText || intl.formatMessage({
    id: 'deficiency.icon.tooltip',
    defaultMessage: 'View deficiency details',
  });

  const tooltipId = `deficiency-tooltip-${deficiency._id}`;

  return (
    <>
      <button
        type="button"
        className={`deficiency-icon no-title ${className || ''}`}
        onClick={handleClick}
        aria-label={tooltip}
        data-for={tooltipId}
        data-tip={tooltip}
      >
        <span className="material-icons">link</span>
      </button>
      <ToolTip id={tooltipId} place="top" />
    </>
  );
};

DeficiencyIcon.propTypes = {
  deficiency: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    status: PropTypes.string,
    description: PropTypes.string,
    reportCategory: PropTypes.string,
    createdAt: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  tooltipText: PropTypes.string,
};

DeficiencyIcon.defaultProps = {
  deficiency: null,
  className: '',
  tooltipText: '',
};

export default injectIntl(DeficiencyIcon);
